<!-- なんらかが原因でURLが不正なページへのアクセスが発生した場合のダイアログ -->

<template>
  <ItemDialog ref="invalidPageAccess" image-type="alert">
    <template #content-area>
      <h2>{{ $t("Errors.invalidPageAccess.title") }}</h2>
      <p class="text-center">
        {{ $t("Errors.invalidPageAccess.description") }}
      </p>
    </template>
    <template #button-area>
      <ItemButton
        :label="$t('Errors.invalidPageAccess.buttonLabel')"
        action-type="btn-primary"
        @clicked="returnNativeApp()"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogInvalidPageAccess",
  methods: {
    async openDialog() {
      this.$refs.invalidPageAccess.open();
    },
  },
};
</script>
